// extracted by mini-css-extract-plugin
module.exports = {"empty":"jut__Icon__empty"};